import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFilterComponent } from './search-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@/material/material.module';
import { SwiperModule } from 'swiper/angular';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SearchFilterComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    SwiperModule,
    FormsModule,
    MatSliderModule,
    TranslateModule,
  ],
  exports: [SearchFilterComponent],
})
export class SearchFilterModule {}
